export const BREAKPOINT = 768;
export const FORCE_MOBILE = 'responsive-carousel--force-mobile';
export const IMAGE_CLASSNAME = 'responsive-carousel__image';
export const ZOOM_CLASSNAME = 'carousel-controls__item--zoom';
export const ZOOM_DATA = 'data-zoom';
export const ZOOM_SELECTOR = `[${ZOOM_DATA}]`;
